import { withLocalState } from 'pyradux';

import FilesContainer from './Files.container';
import reducer from './Files.reducer';
import FilesSagas from './Files.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'files',
  sagas: [FilesSagas],
};

export default withLocalState(withLocalStateOptions, FilesContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Files/index.js